import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MailOutline from "@material-ui/icons/MailOutline";
import Swal from 'sweetalert2'
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance"; 
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import { useNavigate } from "react-router-dom";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import { CircularProgress, TextField } from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
const useStyleData = makeStyles(stylesData);

const useStyles = makeStyles(styles);
const validationSchema = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  nickName: Yup.string(),
  email: Yup.string().email("Invalid email").required("Required"),
  mobileNumber: Yup.string(),
  country: Yup.string(),
  state: Yup.string(),
  city: Yup.string(),
  address: Yup.string(),
  ZipCode: Yup.string(),
  password: Yup.string().min(6, "At least 6 characters").required("Required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required("Required"),
  status: Yup.string().required("Required"),
});

export default function AddUser() {
  const navigate = useNavigate();
  const [alert, setAlert] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      nickName: "",
      email: "",
      password: "",
      confirmPassword: "",
      userType: "",
      mobileNumber: "",
      country: "",
      state: "",
      city: "",
      address: "",
      ZipCode: "",
      status: "true",
      dob: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      const token = localStorage.getItem("token");
      setLoading(true);
      try {
        const { confirmPassword, ...payload } = values;

        const res = await axios.post(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/createPlayer`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        const isSuccess = res.data;
        console.log(isSuccess, "isSuccessisSuccess")
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                {isSuccess && "Player created successfully!"}
              </span>
            }
            onConfirm={hideAlert}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={
              classesSweetAlert.button + " " +
              (isSuccess ? classesSweetAlert.success : classesSweetAlert.error)
            }
          />
        );


      } catch (err) {
        const message = err.response?.data?.message || "Something went wrong!";
        setAlert(
          <SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title={
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                {message}
              </span>
            }
            onConfirm={() => setAlert(null)}
            titleCssClass={classesSweetAlert.cardTitle}
            confirmBtnCssClass={classesSweetAlert.button + " " + classesSweetAlert.error}
          />
        );
      } finally {
        setLoading(false);
      }
    }

  });
  console.log(formik.values, "formik.valuesformik.values")
  const classes = useStyles();
  const classesSweetAlert = useStyleData();

  const hideAlert = () => {
    setAlert(null);
    navigate(`/admin/userManagement`, {
      state: { shouldRefetch: true },
    });
  };

  const renderInput = (label, id, type = "text") => (
    <GridItem xs={12} sm={12} md={3}>
      <CustomInput
        labelText={label}
        id={id}
        error={formik.touched[id] && Boolean(formik.errors[id])}
        helperText={formik.touched[id] && formik.errors[id]}
        formControlProps={{ fullWidth: true }}
        inputProps={{
          value: formik.values[id],
          type
        }}
        handleChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
    </GridItem>
  );

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Add Player</h4>
          </CardHeader>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <GridContainer>
                {renderInput("First Name", "firstName")}
                {renderInput("Last Name", "lastName")}
                {renderInput("Nick Name", "nickName")}
                {renderInput("Email Id", "email")}
                <GridItem xs={12} sm={12} md={3} style={{marginTop:"12px"}}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="DOB"
                      value={formik.values.dob}
                      onChange={(date) => formik.setFieldValue("dob", date)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={formik.touched.dob && Boolean(formik.errors.dob)}
                          helperText={formik.touched.dob && formik.errors.dob}

                        />
                      )}
                    />
                  </LocalizationProvider>
                </GridItem>


                {renderInput("Contact Number", "mobileNumber", "number")}
                {renderInput("Country", "country")}
                {renderInput("State", "state")}
                {renderInput("City", "city")}
                {renderInput("Address", "address")}
                {renderInput("Zip Code", "ZipCode")}
                {renderInput("Password", "password", "password")}
                {renderInput("Confirm Password", "confirmPassword", "password")}


                <GridItem xs={12} sm={12} md={3}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel className={classes.selectLabel}>Status</InputLabel>
                    <Select
                      id="status"
                      name="status"
                      value={formik.values.status}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.status && Boolean(formik.errors.status)}
                      MenuProps={{ className: classes.selectMenu }}
                      classes={{ select: classes.select }}
                    >
                      <MenuItem value={"true"}>Active</MenuItem>
                      <MenuItem value={"false"}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>

                {alert}
              </GridContainer>

              {!loading ? (
                <Button color="rose" type="submit" className={classes.registerButton}>
                  Save
                </Button>
              ) : (
                <div className={classes.registerButton}>
                  <CircularProgress size={24} color="inherit" />
                </div>
              )}
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
